// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/fonts/Reddit_Sans/static/RedditSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/fonts/Reddit_Sans/static/RedditSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/assets/fonts/Reddit_Sans/static/RedditSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/assets/fonts/Reddit_Sans/static/RedditSans-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/src/assets/fonts/Reddit_Sans/static/RedditSans-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/src/assets/fonts/Reddit_Sans/static/RedditSans-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --pmu-primary: #8e2d8e;
  --pmu-primary-light: #c158c1;
  --pmu-primary-dark: #5c005c;
  --pmu-orange: #ff9500;
  --pmu-grey-text: #707070;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar {
  width: 4px;
  height: 2px;
  background-color: transparent !important;
  scroll-behavior: smooth;
  position: relative;
}

::-webkit-scrollbar-thumb {
  background-color: #c158c1 !important;
  border-radius: 8px;
}
@font-face {
  font-family: "Reddit Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
      format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___})
      format("truetype");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: GeneralFont;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: BoldFont;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: ExtraBoldFont;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: LightFont;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
@font-face {
  font-family: ThinFont;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
@font-face {
  font-family: MediumFont;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: RegularFont;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    format("truetype");
}

@font-face {
  font-family: ExtaLightFont;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___})
    format("truetype");
}

h1 {
  font-family: ExtraBoldFont;
}
h2 {
  font-family: BoldFont;
}
h6 {
  font-family: MediumFont;
}
h3 {
  font-family: BoldFont;
}
h4 {
  font-family: BoldFont;
}
h5 {
  font-family: BoldFont;
}
p {
  font-family: RegularFont;
}
* {
  font-family: RegularFont;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,wCAAwC;EACxC,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B;;;wBAGsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,4CAAuE;AACzE;AACA;EACE,qBAAqB;EACrB,4CAAkE;AACpE;AACA;EACE,0BAA0B;EAC1B,4CAAuE;AACzE;AACA;EACE,sBAAsB;EACtB,4CAAmE;AACrE;AACA;EACE,qBAAqB;EACrB,4CAAwE;AAC1E;AACA;EACE,uBAAuB;EACvB,4CAAoE;AACtE;;AAEA;EACE,wBAAwB;EACxB;sBACoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B;sBACoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B","sourcesContent":[":root {\n  --pmu-primary: #8e2d8e;\n  --pmu-primary-light: #c158c1;\n  --pmu-primary-dark: #5c005c;\n  --pmu-orange: #ff9500;\n  --pmu-grey-text: #707070;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar {\n  width: 4px;\n  height: 2px;\n  background-color: transparent !important;\n  scroll-behavior: smooth;\n  position: relative;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #c158c1 !important;\n  border-radius: 8px;\n}\n@font-face {\n  font-family: \"Reddit Sans\";\n  src: url(\"/src/assets/fonts/Reddit_Sans/static/RedditSans-Medium.ttf\")\n      format(\"woff2\"),\n    url(\"/src/assets/fonts/Reddit_Sans/static/RedditSans-Regular.ttf\")\n      format(\"truetype\");\n  font-weight: 400;\n  font-style: normal;\n}\n@font-face {\n  font-family: GeneralFont;\n  src: url(\"/src/assets/fonts/Reddit_Sans/static/RedditSans-Regular.ttf\");\n}\n@font-face {\n  font-family: BoldFont;\n  src: url(/src/assets/fonts/Reddit_Sans/static/RedditSans-Bold.ttf);\n}\n@font-face {\n  font-family: ExtraBoldFont;\n  src: url(/src/assets/fonts/Reddit_Sans/static/RedditSans-ExtraBold.ttf);\n}\n@font-face {\n  font-family: LightFont;\n  src: url(/src/assets/fonts/Reddit_Sans/static/RedditSans-Light.ttf);\n}\n@font-face {\n  font-family: ThinFont;\n  src: url(/src/assets/fonts/Reddit_Sans/static/RedditSans-ExtraLight.ttf);\n}\n@font-face {\n  font-family: MediumFont;\n  src: url(/src/assets/fonts/Reddit_Sans/static/RedditSans-Medium.ttf);\n}\n\n@font-face {\n  font-family: RegularFont;\n  src: url(/src/assets/fonts/Reddit_Sans/static/RedditSans-Regular.ttf)\n    format(\"truetype\");\n}\n\n@font-face {\n  font-family: ExtaLightFont;\n  src: url(/src/assets/fonts/Reddit_Sans/static/RedditSans-ExtraLight.ttf)\n    format(\"truetype\");\n}\n\nh1 {\n  font-family: ExtraBoldFont;\n}\nh2 {\n  font-family: BoldFont;\n}\nh6 {\n  font-family: MediumFont;\n}\nh3 {\n  font-family: BoldFont;\n}\nh4 {\n  font-family: BoldFont;\n}\nh5 {\n  font-family: BoldFont;\n}\np {\n  font-family: RegularFont;\n}\n* {\n  font-family: RegularFont;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
